import React from 'react';

import type { IModalDialogContent, ModalDialogOptions, ModalWindow } from '@components/Modal.tsx';
import { ModalButtonType } from '@components/Modal.tsx';
import { AccessCodeEntry } from '@components/AccessCodeEntry.tsx';

export class EnterCodeDialog extends React.Component implements IModalDialogContent<void> {
  getModalOptions(window: ModalWindow<void>): ModalDialogOptions<void> {
    return {
      title: 'Access by Code',
      width: '320px',
      closeByEscape: true,
      closeOnClickOutside: true,
      buttons: [
        {
          title: 'Close',
          type: ModalButtonType.Cancel,
          onClick: () => window.close(ModalButtonType.Cancel),
        },
      ],
    };
  }

  render() {
    return <AccessCodeEntry />;
  }
}
